// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test'
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

function getLangId() {
    var lang = langify.helper.getSelectedLanguage();
    return lang;
}

BCSfFilter.prototype.prepareSuggestionParams = function(searchTerm, eventType) {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    var enableFuzzy = this.getSettingValue('search.enableFuzzy');
    if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
    if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
    if (this.getSettingValue('search.reduceMinMatch') !== false) {
      params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
    }
    // Get product/variant available or not
    if (this.getSettingValue('search.productAvailable') == true) params.product_available = true;
    // Limit
    var blocks = this.getSettingValue('search.suggestionBlocks');
    var k;
    var blocksLength = blocks.length;
    for (k = 0; k < blocksLength; k++) {
        var id = blocks[k]['type'].slice(0, -1);
        params[id + '_limit'] = blocks[k]['number'];
    }
  
    var lang = getLangId();

    if (lang == 'ly81067') {
      params['lang'] = 'tl1';
    } else if (lang == 'ly79554') {
      params['lang'] = 'tl2';
    }
  
    params['dym_limit'] = this.getSettingValue('search.suggestionDymLimit');
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) param.skipFields = skipFields;
    params.callback = 'BCSfSuggestionCallback';
    params.event_type = eventType;
    // Suggest types
    var suggestionTypes = eventType == 'suggest_dym' ? ['products'] : this.getSettingValue('search.suggestionTypes');
    params.suggest_types = suggestionTypes;
    return params;
};

BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
  if (this.isSearchPage()) {
    params['q'] = this.getSearchTerm();
    if (this.searchTermKey != 'q') delete params[this.searchTermKey];
    var enableFuzzy = this.getSettingValue('search.enableFuzzy');
    if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
    if (this.getSettingValue('search.reduceMinMatch') !== false) {
      params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
    }
    if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
    if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
  
    var lang = bcSfFilterMainConfig.general.langify_lang_id;

    if (lang == 'ly81067') {
      params['lang'] = 'tl1';
    } else if (lang == 'ly79554') {
      params['lang'] = 'tl2';
    }
  }
  return params;
};

BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var self = this;
    var result = '';
    // Buid Header
    result += this.buildSuggestionHeader(itemInfo['label'], 'product');
    // Build Did you mean
    var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
    if (dym != '') {
        result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
    }
  
    var lang = getLangId();

    var title_y = 'title';
  	if (lang == 'ly81067') {
      title_y = 'title_tl1';
    } else if (lang == 'ly79554') {
      title_y = 'title_tl2';
    }
  
    // Build content
    if (Object.keys(itemData).length > 0) {
        // var count = 0;   
        var k;
        var itemDataLength = itemData.length; 
        for (k = 0; k < itemDataLength; k++) {
            // if (count < itemInfo['number']) {
            var product = itemData[k];
            // Get product attributes
            var productTitle = this.customizeSuggetionProductTitle(product[title_y], searchTerm, itemData);
            productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
            var productUrl = this.buildProductItemUrl(product, false);
            var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
            var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
            // Get custom class / attribute
            var searchSuggestionClass = this.class.searchSuggestion;
            var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
            result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
            result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
            // Build Left column
            if (this.getSettingValue('search.showSuggestionProductImage')) {
                result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
            }
            // Build Right column
            result += '<div class="' + searchSuggestionClass + '-right">';
            result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';
            if (this.getSettingValue('search.showSuggestionProductSku')) {
                result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
            }
            if (this.getSettingValue('search.showSuggestionProductVendor')) {
                result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
            }
            result += this.buildSuggestionProductPrice(product);
            result += '</div>'; // End Right column
            result += '</a>'; // End a
            result += '</li>'; // End li
            // count++;
            // } else break;
        }
    }
    return result;
};


/* Start Search Redirect */
function submitSearchFormMobile(t,e){e.preventDefault();var o=bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm);o?window.location.href=o:jQ(t).closest("form").submit()}function beforeSubmitSearchForm(t,e){var o=jQ(t).val(),i=bcsffilter.getSearchRedirectUrl(o);i&&(e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault(),window.location.href=i)}BCSfFilter.prototype.setSuggestionPosition=function(t){var e=this;if("function"==typeof getSuggestionPosition&&"function"==typeof this.checkIsFullWidthSuggestionMobile){var o=getSuggestionPosition(t),i=this.checkIsFullWidthSuggestionMobile(t)?"top":"top+12";"function"!=typeof e.isSuggestionStyle2||e.isSuggestionStyle2(),"left"==o?jQ(t).autocomplete("option","position",{my:"left "+i,at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right "+i,at:"right bottom",collision:"none"})}else"left"==this.getSettingValue("search.suggestionPosition")?jQ(t).autocomplete("option","position",{my:"left top+12",at:"left bottom",collision:"none"}):jQ(t).autocomplete("option","position",{my:"right top+12",at:"right bottom",collision:"none"});if(jQ(t).length>0&&jQ(t).on("keydown",function(o){13==o.keyCode&&e.enterSearchBoxEvent(t,o)}),jQ(t).closest("form").length>0){var n=jQ(t).closest("form").find('[type="submit"]');n&&n.length>0&&n.each(function(e,o){o.setAttribute("onclick","beforeSubmitSearchForm('"+t+"', event)")})}},BCSfFilter.prototype.enterSearchBoxEvent=function(t,e){var o=jQ(t).val(),i=this.getSearchRedirectUrl(o);i&&(e.preventDefault(),window.location.href=i)},BCSfFilter.prototype.getSearchRedirectUrl=function(t){if(this.suggestionCache&&this.suggestionCache.hasOwnProperty(t))for(var e=this.suggestionCache[t],o=0;o<e.length;o++)if("redirect"==e[o].key&&e[o].values){var i=e[o].values;return i=(i=i.replace("https://"+bcSfFilterMainConfig.shop.domain,"")).replace("http://"+bcSfFilterMainConfig.shop.domain,"")}return""};
/* End Search Redirect */
